/* eslint-disable */
// @ts-check
import axios from "axios"
export default {
    methods: {
        /**
            * Método que serve para popular a tabela
            * @param  {Object} params - Objeto padrão usado nos projetos da Unimed
            * @returns {Promise<{ 
                * conteudo: Array<{dataEnvio: String, dataRecebimento: String, nomeArquivo: String, numeroProtocolo: String, status: {chave: String, descricao: String}, unimedDestino: String, unimedOrigem: String}>, 
                * numeroPagina: Number, 
                * tamanhoPagina: Number, 
                * totalElementos: Number, 
                * totalPaginas: Number 
            * }>} 
        */
        getTabelaValidacoes (params) {
            return axios.get(this.CriarUrl({ resource: "validacoes", params }))
        },
        /**
            * Método para retornar todos os status da tabela
            * @return {Promise<Array<String>>}
        */
        getAllStatusValidacao() {
            return axios.get(this.CriarUrl({ resource: "validacoes/status" }))
        },

        /**
            * Recupera todos os analistas
            * @return {Promise<[
            *    {
            *        "cdUnimed": Number,
            *        "email": String,
            *        "idUsuarioUnimed": Number,
            *        "login": String,
            *        "nome": String
            *    }
            *    ]>}
        */
        getAnalistasUnimed() {
            return axios.get(this.CriarUrl({ resource: "analista/all" }));
        }
    }
}